import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import AddTestSuite from './AddTestSuite';
import { createTestSuite, updateTestSuite } from '../../../modules/testsuites';
import { useNotification } from '../../../hooks/NotificationContext';
import { checkRequiredFieldsInCycle } from '../../../lib/executionUtils';
import useExecutionScope from '../../../hooks/useExecutionScope';

const TestSuiteTableAction = ({
  fetchTestSuitesData,
  users,
  setOpenModal,
  open,
  mode = 'add',
  selectedSuite,
  setMode,
  setSelectedSuite,
}) => {
  const { projectId } = useParams();
  const { isScopeDefined, isPlatformsDefined } = useExecutionScope(projectId);

  const initialValues = {
    name: selectedSuite?.name || '',
    description: selectedSuite?.description || '',
    geographies: selectedSuite?.geographies || [],
    languages: selectedSuite?.languages || [],
    cloudDevice: selectedSuite?.cloud_device || [],
    platforms: selectedSuite?.platforms || [],
    subPlatforms: selectedSuite?.sub_platforms || [],
    browsers: selectedSuite?.browsers || [],
  };

  const { addNotification } = useNotification();
  const [responseMessage, setResponseMessage] = useState(null);

  const handleClose = () => {
    setOpenModal(false);
    setMode('add');
    setSelectedSuite(null);
    setResponseMessage(null);
  };

  const handleSave = async (values) => {
    if (isPlatformsDefined) {
      const errorMessage = checkRequiredFieldsInCycle(values);
      if (errorMessage) {
        setResponseMessage(errorMessage);
        return;
      }
    }
    const testsuites = {
      ...values,
      description: values.description.trim(),
      gainssProjectId: projectId,
    };
    try {
      mode === 'edit'
        ? await updateTestSuite({ ...testsuites, id: selectedSuite.id })
        : await createTestSuite(testsuites);
      addNotification('success', 'Test suite added successfully!');
      handleClose();
      fetchTestSuitesData();
    } catch (error) {
      addNotification(
        'error',
        error.message || 'Failed to add project. Please try again.'
      );
    }
  };

  return (
    <AddTestSuite
      fetchTestSuitesData={fetchTestSuitesData}
      associatedUsers={users}
      setOpen={setOpenModal}
      onSubmit={handleSave}
      open={open}
      mode={mode}
      setMode={setMode}
      handleClose={handleClose}
      selectedSuite={selectedSuite}
      initialValues={initialValues}
      error={responseMessage}
      isScopeDefined={isScopeDefined}
      projectId={projectId}
      isPlatformsDefined={isPlatformsDefined}
    />
  );
};

export default TestSuiteTableAction;